import RunWorkflow from "./RunWorkflow";
import UndoRedo from "./UndoRedo";

interface ControlsProps {
  readonly: boolean;
}

const Controls = ({ readonly }: ControlsProps) => (
  <div
    className={`pointer-events-none absolute left-3 right-3 z-[1] flex flex-col gap-y-4 ${
      readonly ? "" : "top-4"
    }`}
  >
    <div className="flex justify-start">{!readonly && <RunWorkflow />}</div>
    {!readonly && <UndoRedo />}
  </div>
);

export default Controls;
